// removed by extract-text-webpack-plugin
module.exports = {"student-panel":"student-panel","setting-section":"setting-section","filter-by":"filter-by","setting-dropdown":"setting-dropdown","student-dropdown":"student-dropdown","dropdown-menu":"dropdown-menu","tab-list":"tab-list","icon-tag":"icon-tag","notice-alert":"notice-alert","sort-by":"sort-by","sort-by-label":"sort-by-label"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Student/Student.scss
// module id = S5pW
// module chunks = 0